const initialState = { }

const authReducer = (state = initialState, action) => {
    return state
}

export default authReducer